export const endpoints = {
  ASSISTANT: '/Assistant',
  AUTHTENTICATION: '/Authentication',
  REVIEWING: '/Reviewing'
};

export const assistantEndpoints = {
  LEGAL_ASSISTANT: `${endpoints.ASSISTANT}/Legal`,
  NAW_LEGAL_ASSISTANT: `${endpoints.ASSISTANT}/Legal/SectionsStream`,
  USER_ASSISTANT: `${endpoints.ASSISTANT}/User`
};

export const reviewingEndpoints = {
  DOCUMENT_SUGGESTIONS: `${endpoints.REVIEWING}/Suggestions`,
  REVIEWING_CHAT: `${endpoints.REVIEWING}/Ask`,
  DOCUMENT_KEYPOINTS: `${endpoints.REVIEWING}/KeyPoints`
};

export const spainAuthenticationEndpoints = {
  LOGIN: `${endpoints.AUTHTENTICATION}/Spain/Login`,
  IS_AUTHENTICATED: `${endpoints.AUTHTENTICATION}/Spain/IsAuthenticated`,
  GET_PRODUCTS: `${endpoints.AUTHTENTICATION}/Spain/Products`,
  LOGOUT: `${endpoints.AUTHTENTICATION}/Spain/Logout`
};
